/**
 * Sparkline.js
 *
 * @class   Sparkline
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Sparkline',

	propTypes: {

	},

	render() {

		return <h3>Sparkline</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/sparkline/SparkLine.js
 **/